import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-logo">PITAC</h3>
          <p>
            Founded in 1962 under the Ministry of Industries, PITAC was created 
            by merging the IRDC and IPC to drive Pakistan's technical workforce 
            development and industrial growth.
          </p>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <Link to="/about">About Us</Link>
          <Link to="/courses">Programs</Link>
          <Link to="/press-releases">Press</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="footer-section">
          <h4>Regional Centres</h4>
          <p className="office-line">📍 Regional Centre Quetta</p>
          <p className="office-line">📍 Regional Centre Karachi</p>
          <p className="office-line">📍 Regional Centre Mirpur</p>
          <p className="office-line">📍 Regional Centre Peshawar</p>
          <p className="office-line">📍 Regional Centre AJK</p>
        </div>

        <div className="footer-section contact-section">
          <h4>Get in Touch</h4>
          <p className="contact-line">📍 234-Ferozepur Road, near Metro Canal Station, Lahore 54600</p>
          <p className="contact-line">📞 +92 4299230699 / +92 4299230702</p>
          <p className="contact-line">✉️ info@pitac.gov.pk</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2026 PITAC. All rights reserved.</p>
        <div className="footer-legal">
          <Link to="#">Privacy Policy</Link>
          <Link to="#">Terms</Link>
          Centre
        </div>
      </div>
    </footer>
  );
};

export default Footer;